module.exports = __webpack_public_path__ + "img/empty_state_cert.c11fdd06.png";